<template>
  <div class="help">
    <!--<el-form ref="ruleForm" :model="form" :rules="rules" label-width="80px">
      <h4 style="text-align: left;">
        親愛的使用者您好，若您對於線上預填資料服務，有任何問題，請與各承辦人員進行聯繫， 謝謝！
      </h4>
      <h5>二技招生系統 聯絡人:李小姐 分機1234</h5>
      <el-form-item label="詢問主題" prop="title">
        <el-input v-model="form.title"></el-input>
      </el-form-item> 
      <el-form-item label="回覆信箱" prop="mail">
        <el-input v-model="form.mail"></el-input>
      </el-form-item> 
      <el-form-item label="詢問內容" prop="contText">
        <el-input type="textarea" v-model="form.contText" :rows=3></el-input>
      </el-form-item> 
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')" icon="el-icon-message">{{$t('message.Send_cmd')}}</el-button>
      </el-form-item>
    </el-form>-->
          <h4 style="text-align: left;">
        親愛的同學您好，若您對於線上預填資料服務，有任何問題，請與各承辦人員進行聯繫， 謝謝！<br>
        <h5>1.	學雜費減免業務　：聯絡人:李小姐 分機7022</h5>
        <h5>2.	就學貸款業務　　：聯絡人:王小姐 分機7021</h5>
        <h5>3.	校內宿舍業務　　：聯絡人:王小姐 分機7021</h5>
        <h5>4.	兵役業務　　　　：聯絡人:李小姐 分機7022</h5>
        <h5>5.	金融機構資料　　：聯絡人:蔡先生 分機7023</h5>
      </h4>
      
  </div> 
</template>

<script>
export default {
  name: 'help',
  data () {
    var checkContText = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('詢問內容不能空白'));
      } else {
          callback();
      }
    };
    var checkMail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('信箱不能空白'));
      } else {
          callback();
      }
    };
    var checkTitle = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('主題不能空白'));
      } else {
          callback();
      }
    };
    return {
      form: {
        title: '',
        mail: '',
        contText: '',
        sysId: 0,
        id: '',
        status: 0,
        name: '',
        type: 0,
      },
      rules:{
       title:[{validator: checkTitle,trigger:"blur"}],
       mail:[{validator: checkMail,trigger:"blur"}],
       contText:[{validator: checkContText,trigger:"blur"}],
      }
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    onSubmit() {
      this.$http.put('./WebApi/Tools/SendMail',this.form)
                .then((response) =>{ 
                    const h = this.$createElement;       
                    if (true == response.data) {
                      this.$message({
                        message: '恭喜您,寄件成功',
                        type: 'success'
                      });
                    } else {
                      this.$message.error('對不起,寄件失敗');
                    }
                })
                .catch(function (error) {
                  this.$message.error('對不起,網路連線失敗');
                })
    },
    submitForm(ruleForm) {
      this.$refs.ruleForm.validate((valid) => {        
        console.log('======submitForm ===== valid:'+valid)
        if (valid) {
          this.$http.put('./WebApi/Tools/SendMail',this.form)
                    .then((response) =>{ 
                        const h = this.$createElement;       
                        if (true == response.data) {
                          this.$message({
                            message: '恭喜您,寄件成功',
                            type: 'success'
                          });
                        } else {
                          this.$message.error('對不起,寄件失敗');
                        }
                    })
                    .catch(function (error) {
                      this.$message.error('對不起,網路連線失敗');
                    })
        } else {
          this.$message.error('對不起,驗證失敗');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$nextTick(function() {
        this.$refs[formName].resetFields();
      })
    }
  },
  created () {
    console.log('======created Help =====')
    
    this.form.sysId = this.sysId;
    this.form.id = this.user.id;
    this.form.status = this.user.status;
    this.form.name = this.user.name;
    this.form.type = this.user.type;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/HelpView.vue